import { Controller } from "stimulus"
import { isNativeApp, postToNative } from "../lib/native_bridge"

// Ticket 136 — houd het scherm aan tijdens een training, zodat een tablet niet
// halverwege in slaap valt. In de native schil gaat dit via de bridge (de app
// zet een echte wake lock); in de browser via de Screen Wake Lock API. Beide
// best-effort: lukt het niet, dan faalt de training niet.
//
// Gebruik: data-controller="wake-lock" op het trainingsscherm.
export default class extends Controller {
  connect() { this.enable() }
  disconnect() { this.release() }

  async enable() {
    if (isNativeApp()) { postToNative("wakeLock", "enable"); return }
    try {
      if ("wakeLock" in navigator) {
        this.sentinel = await navigator.wakeLock.request("screen")
        document.addEventListener("visibilitychange", this.reacquire)
      }
    } catch (e) { /* stil: wake lock is best-effort */ }
  }

  reacquire = async () => {
    if (document.visibilityState === "visible" && !isNativeApp() && "wakeLock" in navigator) {
      try { this.sentinel = await navigator.wakeLock.request("screen") } catch (e) { /* stil */ }
    }
  }

  release() {
    if (isNativeApp()) { postToNative("wakeLock", "release"); return }
    document.removeEventListener("visibilitychange", this.reacquire)
    if (this.sentinel) { this.sentinel.release?.(); this.sentinel = null }
  }
}
